// The Swallow Co
import './main.css';

import Alpine from 'alpinejs';
import BlazeSlider from 'blaze-slider';
import { inView, animate, scroll } from 'motion';
import { Ajaxinate } from 'ajaxinate';
import Countup from './countup';

import OrangeSection from './orange-section';
import ComparisonDetails from './comparison-details';
import Ingredients from './ingredients';
import Cart from './cart';
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Search from './search';
import CollectionList from './collection-list';
import ProductCta from './product-cta';
import faqs from './faqs';
import addToCart from './add-to-cart';

Cart();
Ingredients();
Search();
CollectionList();
ProductCta();
faqs();
addToCart();

window.Alpine = Alpine;
window.cart = [];
window.cart_skus = '';

/**
 * Update the cart sku string with the current cart items.
 */
function updateCartSkus() {
  let skus = '';
  window.cart.forEach((item) => {
    skus += item.sku + ', ';
  });

  window.cart_skus = skus;

  document.dispatchEvent(new CustomEvent('cart:skus-updated', { detail: skus }));
}

window.updateCartSkus = updateCartSkus;

Alpine.magic('money', (el, { Alpine }) => {
  return (cents, format) => {
    if (format) {
      format = '£{{' + format + '}}';
    }

    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '£{{amount}}';

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
});

Alpine.start();

const init = () => {
  const media = window.matchMedia('(max-width: 1023px)');
  let isMobile = media.matches;
  const bodyClass = document.body.classList;
  const header = document.querySelector('.header');
  let animIn = document.querySelectorAll('.animate-in');
  const announcementSlider = document.querySelector('.announcement-slider');
  const productsCarouselSlider = document.querySelectorAll('.products-carousel-slider');
  const productGallerySlider = document.querySelector('.product-gallery');
  const benefitsSlider = document.querySelectorAll('.benefits-carousel-slider');
  const reviewsSlider = document.querySelectorAll('.reviews-slider');
  const ingredientsSlider = document.querySelectorAll('.ingredients-carousel-slider');
  const ingredientsSliderDesktop = document.querySelectorAll('.ingredients-carousel-slider-desktop');

  Countup();
  ComparisonDetails();
  OrangeSection();

  media.addEventListener('change', (e) => {
    isMobile = e.matches;
  });

  console.log('👋 This theme was made by Giant Peach. (https://giantpeach.agency)');

  if (bodyClass.contains('index') && !isMobile) {
    scroll(
      animate(header, {
        backgroundColor: ['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 1)'],
      }),
      {
        offset: ['0px', '200px'],
      }
    );
  }

  if (isMobile) {
    header.classList.add('bg-white');
  }

  const inViewAnim = ({ target }) => {
    target.classList.add('is-visible');

    return () => {
      target.classList.remove('is-visible');
    };
  };

  let inViewStop = inView(animIn, inViewAnim, {
    margin: '0px 0px -5% 0px',
  });

  new Ajaxinate({
    callback: () => {
      animIn = document.querySelectorAll('.animate-in');
      inViewStop();
      inViewStop = inView(animIn, inViewAnim, {
        margin: '0px 0px -5% 0px',
      });
    },
  });

  if (announcementSlider) {
    new BlazeSlider(announcementSlider, {
      all: {
        enableAutoplay: true,
      },
    });
  }

  if (productsCarouselSlider) {
    productsCarouselSlider.forEach((slider) => {
      const container = slider.closest('.products-carousel');

      const nextBtn = container.querySelector('.next');
      const prevBtn = container.querySelector('.prev');

      const prdSlider = new BlazeSlider(slider, {
        all: {
          enablePagination: true,
          enableAutoplay: true,
          slidesToShow: 1,
        },
        '(min-width: 768px)': {
          slidesToShow: 3,
        },
      });

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          prdSlider.next();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prdSlider.prev();
        });
      }
    });
  }

  if (productGallerySlider) {
    new BlazeSlider(productGallerySlider, {
      all: {
        enablePagination: true,
      },
    });
  }

  if (reviewsSlider.length > 0) {
    reviewsSlider.forEach((slider) => {
      new BlazeSlider(slider, {
        all: {
          slidesToShow: 1.25,
          enablePagination: true,
        },
      });
    });
  }

  if (ingredientsSlider) {
    ingredientsSlider.forEach((slider) => {
      const nextBtn = slider.querySelector('.next');
      const prevBtn = slider.querySelector('.prev');
      const ingSlider = new BlazeSlider(slider, {
        all: {
          slidesToShow: 1,
          enablePagination: false,
          enableAutoplay: true,
        },
      });

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          ingSlider.next();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          ingSlider.prev();
        });
      }
    });
  }

  if (ingredientsSliderDesktop) {
    ingredientsSliderDesktop.forEach((slider) => {
      const nextBtn = slider.querySelectorAll('.next');
      const prevBtn = slider.querySelectorAll('.prev');
      const ingSlider = new BlazeSlider(slider, {
        all: {
          slidesToShow: 1,
          enablePagination: false,
          enableAutoplay: true,
          autoplayInterval: 7000,
          transitionDuration: 1000,
        },
      });

      if (nextBtn) {
        nextBtn.forEach((btn) => {
          btn.addEventListener('click', () => {
            ingSlider.next();
          });
        });
      }

      if (prevBtn) {
        prevBtn.forEach((btn) => {
          btn.addEventListener('click', () => {
            ingSlider.prev();
          });
        });
      }
    });
  }

  if (benefitsSlider) {
    benefitsSlider.forEach((slider) => {
      const container = slider.closest('.benefits-carousel');

      const nextBtn = container.querySelector('.next');
      const prevBtn = container.querySelector('.prev');

      const benSlider = new BlazeSlider(slider, {
        all: {
          enablePagination: true,
          enableAutoplay: true,
        },
        '(min-width: 768px)': {
          slidesToShow: 2,
        },
        '(min-width: 1280px)': {
          slidesToShow: 2.5,
        },
        '(min-width: 1440px)': {
          slidesToShow: 3.25,
          enablePagination: false,
        },
        '(min-width: 1530px)': {
          slidesToShow: 3.5,
          enablePagination: false,
        },
      });

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          benSlider.next();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          benSlider.prev();
        });
      }
    });
  }

  document.addEventListener('scroll:lock', (e) => {
    if (e.detail?.element) {
      disableBodyScroll(e.detail.element);
    }
  });

  document.addEventListener('scroll:unlock', (e) => {
    if (e.detail?.element) {
      enableBodyScroll(e.detail.element);
    } else {
      clearAllBodyScrollLocks();
    }
  });

  document.addEventListener('cart:skus-updated', () => {
    if (typeof wisepops !== 'undefined') {
      console.log('wisepops cart skus: ', window.cart_skus);
      wisepops('properties', {
        swallow_cart: window.cart_skus,
      });
      setTimeout(() => {
        wisepops('event', 'cart_updated');
      }, 500);
    }
  });

  document.addEventListener('cart:product-added', (e) => {
    console.log('sku added: ', e.detail);
    if (typeof wisepops !== 'undefined') {
      sessionStorage.setItem('last_variant_added_cart', e.detail.variant);
      sessionStorage.setItem('last_variant_selling_plan', e.detail.selling_plan);

      console.log(window.cart_skus);

      wisepops('properties', {
        cart: {
          item: e.detail.sku,
        },
        swallow_cart: window.cart_skus,
      });
      setTimeout(() => {
        //wisepops('event', 'add_to_cart');
        wisepops('event', 'add_to_cart_two');
      }, 500);
    }
  });
};

if (document.readyState !== 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}

document.addEventListener('wisepop:upsell-clicked', function (e) {
  console.log('wisepop:upsell-clicked', e);
});
